export default "__VITE_PUBLIC_ASSET__9b88ced3__"